<template>
	<div>
		<tab name="2"></tab>
		<div>
			<div class="page-filter-box">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					    <el-date-picker
					        v-model="params.startTime"
					        type="date"
					        placeholder="对账起始日期"
					        value-format="yyyyMMdd"
					        size="small"
					        :clearable="false"
					        :editable="false">
					    </el-date-picker>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					    <el-date-picker
					        v-model="params.endTime"
					        type="date"
					        placeholder="对账结束日期"
					        value-format="yyyyMMdd"
					        size="small"
					        :clearable="false"
					        :editable="false">
					    </el-date-picker>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.type" placeholder="请选择" size="small">
							<el-option label="不限制退款渠道" value=""></el-option>
							<el-option label="仅看支付宝的-旧" :value="1"></el-option>
							<el-option label="仅看微信支付的-旧" :value="2"></el-option>
							<el-option label="仅看财付通的-旧" :value="3"></el-option>
							<el-option label="仅看抖音小程序的" :value="4"></el-option>
							<el-option label="仅看支付宝的" :value="6"></el-option>
							<el-option label="仅看微信支付的" :value="7"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.diffType" placeholder="请选择异常类型" size="small">
							<el-option label="不限制异常类型" value=""></el-option>
							<el-option label="秀动多出" :value="0"></el-option>
							<el-option label="支付平台多出" :value="1"></el-option>
							<el-option label="金额不一致" :value="2"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.dealStatus" placeholder="请选择处理状态" size="small">
							<el-option label="不限制处理状态" value=""></el-option>
							<el-option label="待处理" :value="0"></el-option>
							<el-option label="已处理" :value="1"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-input v-model="params.orderSn" class="input-with-select" size="small" placeholder="请输入订单编号">
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-input v-model="params.refundNo" class="input-with-select" size="small"
							placeholder="请输入系统退款单号">
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-input v-model="params.transactionNo" class="input-with-select" size="small"
							placeholder="请输入平台退款流水号">
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-input v-model="params.dealUser" class="input-with-select" size="small" placeholder="请输入处理人">
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
						<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
						<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
					</el-col>
				</el-row>
			</div>
			<div v-if="$utils.have('/finance/refund/diff/xport')" class="page-btns-box">
				<el-button v-if="$utils.have('/finance/refund/diff/xport')" type="primary" icon="el-icon-download"
					size="small" @click="download" :loading="downLoading">导出异常明细</el-button>
				<el-button v-if="$utils.have('/finance/refund/diff/deal')" type="primary" size="small" @click="process(orderSns,1)">批量登记处理</el-button>
			</div>
			<div class="page-list-box">
				<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
					@selection-change="handleSelectionChange">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="date" label="对账日期"></el-table-column>
					<el-table-column prop="typeStr" label="退款渠道"></el-table-column>
					<el-table-column prop="diffTypeStr" label="异常类型"></el-table-column>
					<el-table-column prop="orderSn" label="订单编号" min-width="120"></el-table-column>
					<el-table-column prop="transactionNo" label="平台退款流水号" min-width="140"></el-table-column>
					<el-table-column prop="platformRefundTime" label="平台退款时间" min-width="130"></el-table-column>
					<el-table-column prop="platformRefundAmount" label="平台退款金额"></el-table-column>
					<el-table-column prop="systemRefundAmount" label="系统退款金额"></el-table-column>
					<el-table-column prop="refundOrderNo" label="系统退款单号"></el-table-column>
					<el-table-column prop="systemRefundTime" label="系统退款成功时间" min-width="130"></el-table-column>
					<el-table-column prop="dealStatusStr" label="处理状态"></el-table-column>
					<el-table-column prop="dealRemark" label="处理备注" min-width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="statusStr" label="操作">
						<template slot-scope="scope">
						    <el-button v-if="$utils.have('/finance/refund/diff/deal') && scope.row.dealStatusStr != '已处理'" type="text" size="small"
						        @click="process(scope.row.orderSn,2)">登记处理</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="data" class="page-pagination-box">
				<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
					:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
					layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
				</el-pagination>
			</div>
			<process ref="Process" @onUpdate="getDataList"></process>
		</div>
	</div>
</template>

<script>
	import Tab from './components/tab';
	import Process from './components/process';
	const defaultParams = {
		pageNo: 1,
		type: '',
		dealStatus: '',
		diffType: '',
		orderSn: '',
		refundNo: '',
		transactionNo: '',
		dealUser: '',
		startTime:'',
		endTime:''
	}
	export default {
		components: {
			Tab,
			Process
		},
		data() {
			return {
				data: null,
				dataList: null,
				
				timeType: 1,
				listLoading: false,
				downLoading: false,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					dealStatus: parseInt(this.$route.query.status) || '',
					diffType: (() => {
					  const val = this.$route.query.diffType;
					  return val !== undefined && val !== '' ? Number(val) : '';
					})(),
					type: parseInt(this.$route.query.type) || '',
					startTime: this.$route.query.startTime && this.$route.query.startTime.replace(/-/g, '') || '',
					endTime: this.$route.query.endTime && this.$route.query.endTime.replace(/-/g, '') || '',
				},
				orderSns: ''
			}

		},
		mounted() {

			this.getDataList();
		},
		methods: {
			getDataList() {
				this.listLoading = true;
				this.$request({
						url: '/finance/refund/diffList',
						method: "POST",
						data: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result || null;
							this.dataList = result.result || [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.data = null;
						this.dataList = [];
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {				
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			//全选、反选
			handleSelectionChange(val) {
				this.orderSns = val.map(v => v.orderSn);
			},			
			download() {
			    this.downLoading = true;
			    this.$request({
			        url: '/finance/refund/diff/xport',
			        method: "POST",
			        data: {
			            ...this.params
			        },
			    })
			        .then((res) => {
			            const { state, msg } = res.data;
			            if (state == 1) {
			                this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
			                    confirmButtonText: '立即查看',
			                    cancelButtonText: '稍后再看',
			                    type: 'success',
			                    center: true,
			                    closeOnClickModal: false
			                }).then(() => {
			                    this.$router.push({ path: '/workbench/downloadList' })
			                }).catch(() => { })
			            } else {
			                this.$message.error(msg || "请求失败");
			            }
			        })
			        .catch(() => {
			            this.$message.error("请求错误");
			        })
			        .finally(() => {
			            this.downLoading = false;
			        });
			},
			process(orderSn,type){
				if( type == 1 && this.orderSns ==='' ){
					return this.$message.warning('请先选择需要批量处理的数据');
				}
				this.$refs.Process.show(orderSn,type)
			}

		}
	}
</script>

<style lang="scss" scoped>

</style>